var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"sf-flex-column h-100"},[_c('div',{staticClass:"sf-col sf-col-25"},[_c('sf-card',{staticClass:"p-0 border-0 bg-transparent h-100"},[_c('pwa-appr-table-container',{ref:"tableContainer",attrs:{"scrId":_vm.scrId}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }